// TermsAndConditions.js
import React, { useState } from "react";
import "../t&c.css";

function TermsAndConditions() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Trigger */}
      <div className="tnc-trigger" onClick={() => setShowModal(true)}>
        T&C
      </div>

      {/* Modal */}
      {showModal && (
        <div className="tnc-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="tnc-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="tnc-title">Terms & Conditions</h2>
            <div className="tnc-grid">
              {/* Section 1 */}
              <div className="tnc-item">
                <i className="fas fa-clipboard-check"></i>
                <h4>Booking & Acceptance</h4>
                <ul>
                  <li>All consignments are at owner's risk.</li>
                  <li>Consignor must provide required legal documents.</li>
                  <li>Firm can detain goods for wrong declaration.</li>
                  <li>Accepting the consignment note implies agreement to T&C.</li>
                  <li>Self-booking delivery requires consignee copy or indemnity bond.</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div className="tnc-item">
                <i className="fas fa-shipping-fast"></i>
                <h4>Delivery & Claims</h4>
                <ul>
                  <li>Claims valid only during open delivery.</li>
                  <li>Demurrage applies after 7 days.</li>
                  <li>Goods unsold after 45 days may be sold.</li>
                  <li>One-time door delivery, re-attempts are chargeable.</li>
                  <li>No POD available after 1 month.</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div className="tnc-item">
                <i className="fas fa-balance-scale"></i>
                <h4>Freight & Financials</h4>
                <ul>
                  <li>Firm may reweigh/recalculate charges.</li>
                  <li>Rebooking only in as-is condition, paymode only.</li>
                  <li>Transit insurance not covered unless requested.</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="tnc-item">
                <i className="fas fa-shield-alt"></i>
                <h4>Liability & Legal</h4>
                <ul>
                  <li>Firm not liable for loss due to natural causes, theft, strikes, etc.</li>
                  <li>Prohibited goods must not be booked.</li>
                  <li>Jurisdiction lies with Bangalore courts.</li>
                </ul>
              </div>
            </div>
            <button className="tnc-close" onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
}

export default TermsAndConditions;
